<template>
  <router-link v-if="to" :to="to" class="flex" :class="additionalClasses">
    <i v-if="src" :class="`icon-${src}`" class="text-20 mr-5" />
    <p v-if="label">{{ label }}</p>
    <slot />
  </router-link>
  <a v-else-if="href" :href="href" :target="target" :class="additionalClasses">
    <i v-if="src" :class="`icon-${src}`" class="text-20 mr-5" />
    <p v-if="label">{{ label }}</p>
    <slot />
  </a>
</template>

<script setup lang="ts">
const props = defineProps({
  to: { type: String },
  href: { type: String },
  label: { type: String, default: "" },
  src: { type: String, default: "" },
  additionalClasses: { type: String, default: "" },
  target: { type: String, default: "_blank" },
});
</script>
